type LayoutOptions = {
  workspace: boolean;
  expanded?: boolean;
  interactionClassName?: string;
};

type PreviewColumnOptions = {
  workspace: boolean;
  minHeightClassName?: string;
  allowOverflow?: boolean;
};

type PreviewFrameOptions = {
  workspace: boolean;
  sticky?: boolean;
};

function classNames(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export function getFormEditorLayoutClassName({
  workspace,
  expanded = false,
  interactionClassName,
}: LayoutOptions) {
  return classNames(
    '[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
    workspace
      ? classNames(
          'flex flex-col gap-6 overflow-visible lg:grid lg:items-start lg:gap-6 lg:transition-[grid-template-columns] lg:duration-300 lg:ease-out',
          expanded
            ? 'lg:grid-cols-[minmax(0,36fr)_minmax(0,64fr)]'
            : 'lg:grid-cols-[minmax(0,56fr)_minmax(0,44fr)]',
        )
      : 'block space-y-6 mt-3 h-full min-h-0 overflow-y-auto lg:space-y-0 lg:flex lg:flex-row lg:gap-6',
    interactionClassName,
  );
}

export function getFormEditorPreviewColumnClassName({
  workspace,
  minHeightClassName,
  allowOverflow = false,
}: PreviewColumnOptions) {
  return classNames(
    'flex shrink-0 flex-col gap-4 lg:shrink',
    minHeightClassName,
    workspace ? 'order-2 min-w-0 scroll-mt-14 outline-none' : 'pr-2 lg:w-1/2',
    allowOverflow && 'lg:overflow-visible',
  );
}

export function getFormEditorConfigurationColumnClassName({ workspace }: { workspace: boolean }) {
  return classNames(
    'flex h-auto shrink-0 flex-col pb-14 md:pb-0 lg:shrink lg:overflow-visible',
    workspace ? 'compact-editor-controls order-1 min-w-0 scroll-mt-14 outline-none' : 'lg:w-1/2 lg:pl-4',
  );
}

export function getFormEditorPreviewFrameClassName({
  workspace,
  sticky = true,
}: PreviewFrameOptions) {
  return workspace
    ? classNames(
        'overflow-hidden rounded-lg border border-edge lg:h-[calc(100vh-8rem)] lg:min-h-[520px]',
        sticky && 'lg:sticky lg:top-3',
      )
    : 'rounded-lg border border-edge';
}
